<template>
	<div class="mobile-single-filter">
		<div class="mobile-single-filter__title">{{ i18nService.$tDynamic('modules.cars_module.cars.filters', filter.title) }}</div>
		<div v-if="filter.filterName === EFilterNames.GROUP && allGroups" class="mobile-single-filter__values-container">
			<div v-for="(item, i) in allGroups" :key="i" class="mobile-single-filter__value">
				<GlobalCheckbox v-if="item" v-model="selectedGroups" readonly :value="item.name" @click="carsStore.setCurrentGroup(item)">
					{{
						typeof item.name === 'string'
							? i18nService.$tDynamic('data.group_map_translations', groupMapTranslations[item.name])
							: item.name
					}}
				</GlobalCheckbox>
			</div>
		</div>
		<div v-else-if="!filter.isSeats && parameter?.values" class="mobile-single-filter__values-container">
			<div v-for="(item, i) in parameter.values" :key="i" class="mobile-single-filter__value">
				<GlobalCheckbox
					v-if="parameter"
					v-model="selectedValues"
					readonly
					:value="item"
					@click="carsStore.setCurrentFilterByValue(parameter, item)"
					>{{
						typeof item === 'string' ? i18nService.$tDynamic('data.group_map_translations', parametersMapTranslations[item]) : item
					}}</GlobalCheckbox
				>
			</div>
		</div>
		<div v-else-if="filter.isSort" class="mobile-single-filter__values-container">
			<v-radio-group v-model="carsStore.getCurrentSorting" hide-details>
				<GlobalRadio
					v-for="(item, i) in filter.items"
					:key="i"
					class="cars-filter__filter-menu-radio"
					readonly
					density="compact"
					color="var(--primary-color)"
					:label="i18nService.$tDynamic('modules.cars_module.cars.filters', item.name)"
					:value="item"
					@click="carsStore.setCurrentSorting(item as ICarSorting)" />
			</v-radio-group>
		</div>
		<div v-else-if="filter.isSeats" class="mobile-single-filter__values">
			<v-slider
				v-model="selectedSeats"
				class="mobile-single-filter__slider"
				:ticks="seatsLabels"
				:step="1"
				hide-details
				show-ticks="always"
				tick-size="0"
				thumb-color="var(--primary-color)"
				track-fill-color="var(--primary-color)"
				track-color="var(--stroke-on-background)"
				:track-size="4"
				:min="1"
				:thumb-size="16"
				:max="5" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { EFilterNames } from '@/modules/carsModule/types/filters'

const carsStore = useCarsStore()
const selectedValues = ref<string[] | number[]>([])
const selectedGroups = ref<string[]>()
const selectedSeats = ref<number>()
const selectedPriceRange = ref<IPriceRange>()
const i18nService = usei18nService()
const $t = useI18n().t
export interface ISingleFilterProps {
	title: string
	filterName?: EFilterNames
	items?: {
		name: string
		value: string
	}[]
	disabled?: boolean
	isSeats?: boolean
	isSort?: boolean
}

const componentProps = defineProps<{
	filter: ISingleFilterProps
}>()

const parameter = computed(() => {
	if (componentProps.filter.filterName) {
		return carsStore.getFilterByParameterName(componentProps.filter.filterName)
	} else {
		return undefined
	}
})

const allGroups = computed(() => carsStore.getAllGroups?.filter((group) => group.name !== 'electric' && group.name !== 'automatic'))

const seatsLabels = {
	1: $t('common.any_short'),
	2: '2+',
	3: '4+',
	4: '5+',
	5: '7+',
}

watch(
	() => selectedSeats.value,
	(val) => {
		if (parameter.value) {
			switch (val) {
				case 1:
					carsStore.setCurrentFilter(parameter.value, undefined, undefined)
					break
				case 2:
					carsStore.setCurrentFilter(parameter.value, undefined, 2)
					break
				case 3:
					carsStore.setCurrentFilter(parameter.value, undefined, 4)
					break
				case 4:
					carsStore.setCurrentFilter(parameter.value, undefined, 5)
					break
				case 5:
					carsStore.setCurrentFilter(parameter.value, undefined, 7)
					break
			}
		}
	},
	{ deep: true, immediate: true },
)

// watch(
// 	() => selectedPriceRange.value,
// 	(value) => {
// 		if (value) {
// 			carsStore.setCurrentPriceRange(value)
// 		}
// 	},
// 	{ deep: true, immediate: true },
// )

watch(
	() => carsStore.getCurrentPriceRange,
	(currentPriceRange) => {
		selectedPriceRange.value = currentPriceRange as IPriceRange
	},
	{ deep: true, immediate: true },
)

watch(
	() => carsStore.getCurrentFilters,
	(currentFilters) => {
		if (parameter.value) {
			const currentFilter = carsStore.getCurrentFilterById(parameter.value.id)

			selectedValues.value = currentFilter?.values ? currentFilter.values : []

			if (componentProps.filter.isSeats && !currentFilters?.find((filter) => filter.parameter?.name === 'Seats')) {
				selectedSeats.value = undefined
			}
		}
	},
	{ deep: true, immediate: true },
)

watch(
	() => carsStore.getCurrentGroups,
	(currentGroups) => {
		if (componentProps.filter.filterName === EFilterNames.GROUP) {
			selectedGroups.value = currentGroups?.map((group) => group.name)
		}
	},
	{ deep: true, immediate: true },
)
</script>

<style lang="scss">
@import './SingleFilter';
</style>
